import termsRoutes from '../../../routes/terms';

export const ONLY_LOGO_ROUTES = [
  termsRoutes()[0].path,
];

export default function isOnlyLogoRoute(pathname = '') {
  return ONLY_LOGO_ROUTES.some((route) => pathname.startsWith(route));
}
